import Button from '@atlaskit/button/new';
import ArrowLeftIcon from '@atlaskit/icon/core/arrow-left';
import ClockIcon from '@atlaskit/icon/core/clock';
import LocationIcon from '@atlaskit/icon/core/location';
import ShareIcon from '@atlaskit/icon/core/share';
import { Flex, Stack } from '@atlaskit/primitives/compiled';
import { media } from '@atlaskit/primitives/responsive';
import { token } from '@atlaskit/tokens';
import {
  Button as LearningComponentsButton,
  ButtonAppearance,
  Heading,
  Icon,
  Text,
} from '@atlassian/learning-components';
import { css } from '@compiled/react';
import { useLoaderData, useNavigate } from 'react-router-dom';

import { useBreakpoint } from 'src/hooks/useBreakpoint';
import { useScreenEvent } from 'src/hooks/useScreenEvent';

import { RichContent } from '../../RichContent';
import { LoaderResponse } from './loader';
import { FaqSection } from './FaqSection';

export const PrivateClassPage = () => {
  const navigate = useNavigate();
  const { isMobile } = useBreakpoint();
  const { iltData } = useLoaderData() as LoaderResponse;

  useScreenEvent({ eventName: 'teamTrainingScreen' });

  const onBackClick = () => navigate(-1);

  const onShareClick = () => {};

  const onHostClick = () => {};

  const onScheduleClick = () => navigate('partners');

  return (
    <>
      <div css={headerContainerStyles}>
        <Flex gap="space.200" alignItems="center" justifyContent="space-between">
          <Button
            iconBefore={(iconProps) => <ArrowLeftIcon {...iconProps} color={token('color.text.brand')} />}
            appearance="subtle"
            onClick={onBackClick}
          >
            <span css={buttonTextStyles}>Back</span>
          </Button>
          <Button
            iconAfter={(iconProps) => <ShareIcon {...iconProps} color={token('color.text.brand')} />}
            appearance="subtle"
            onClick={onShareClick}
          >
            <span css={buttonTextStyles}>Share</span>
          </Button>
        </Flex>
        <Heading level={0}>{iltData?.courseTitleExternal || 'Live Team Training'}</Heading>
        <div css={metaInfoStyles}>
          <Flex alignItems="center" gap="space.400">
            <Stack space="space.100">
              <Flex alignItems="center" gap="space.050">
                <ClockIcon label="duration" color={token('color.text.brand')} /> <Text size="small">DURATION</Text>
              </Flex>
              <Text size="large">{iltData?.duration ? `${iltData.duration} hours` : '4 hours'}</Text>
            </Stack>
            <Stack space="space.100">
              <Flex alignItems="center" gap="space.050">
                <LocationIcon label="published" color={token('color.text.brand')} /> <Text size="small">PUBLISHED</Text>
              </Flex>
              <Text size="large">Online</Text>
            </Stack>
          </Flex>
          <Flex gap="space.200" alignItems="center">
            <LearningComponentsButton
              fullWidth={isMobile}
              label="Host this class"
              appearance={ButtonAppearance.SECONDARY}
              iconAfter={<Icon type="arrow-right" />}
              onClick={onHostClick}
            />
            <LearningComponentsButton
              fullWidth={isMobile}
              label="Schedule a private class"
              appearance={ButtonAppearance.PRIMARY}
              onClick={onScheduleClick}
            />
          </Flex>
        </div>
      </div>

      <RichContent iltData={iltData} />
      <FaqSection faqData={iltData?.faqSection} />
    </>
  );
};

const headerContainerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: token('space.400'),
  width: '100%',
  paddingBottom: token('space.400'),
  borderBottom: `1px solid ${token('color.border')}`,
});

const buttonTextStyles = css({
  color: token('color.text.brand'),
  textAlign: 'center',
  fontFamily: 'Charlie Text',
  fontSize: '1rem',
  fontStyle: 'normal',
  fontWeight: 600,
  lineHeight: '1.25rem',
});

const metaInfoStyles = css({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  gap: token('space.400'),

  [media.above.sm]: {
    flexDirection: 'row',
    gap: token('space.400'),
  },
});
